<ng-container *ngIf="vc$ | async as vc">
  <pw-view-title>
    <div class="title-max-width">{{ vc.TEXT }}</div>
  </pw-view-title>

  <pw-view-actions>
    <button mat-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <button mat-button (click)="openDrawer()">
      <mat-icon>filter_list</mat-icon>
    </button>
  </pw-view-actions>

  <pw-view-drawer>
    <div style="display: flex; flex-direction: column; gap: 1rem; padding: 1rem">
      <mat-slide-toggle [formControl]="onlyAssignedTasks">
        {{ 'planning.showTasks.myTasks' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle [formControl]="includeFinished">
        {{ 'planning.showTasks.includeFinished' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle [formControl]="includeUnplanned">
        {{ 'planning.showTasks.includeUnplanned' | translate }}
      </mat-slide-toggle>

      <button style="grid-column: auto / span 2; justify-self: end" mat-button
              (click)="currentViewService.drawer.toggle()"
              color="accent">{{ 'planning.showTasks.cancel' | translate }}
      </button>
    </div>
  </pw-view-drawer>

  <mat-menu #menu="matMenu">
    <button mat-menu-item routerLink="/general/qr-code/{{ vc?.OBJECT_ID }}">
      <span>QR-Code</span>
    </button>
  </mat-menu>

  <div class="mw-70">
    <mat-expansion-panel>
      <mat-expansion-panel-header>{{ vc.TEXT }}</mat-expansion-panel-header>
      <div
        style="display: grid; grid-template-columns: auto 1fr; grid-gap: 12px">
        <div style="font-weight: bold">Name</div>
        <div>{{ vc.NAME }}</div>
        <div style="font-weight: bold">
          {{ 'general.infoPanels.vc.description' | translate }}
        </div>
        <div>{{ vc.DESCRIPTION }}</div>
        <div style="font-weight: bold">
          {{ 'general.infoPanels.vc.type' | translate }}
        </div>
        <div>{{ vc.CONTAINER_NAME }}</div>
      </div>
    </mat-expansion-panel>

    <div style="padding-top: 1rem" [ngClass]="(isPhone$ | async) ? 'search-container-mobile' : 'search-container'">
      <mat-form-field>
        <input
          matInput
          placeholder="Filter"
          [formControl]="searchFormControl"/>
      </mat-form-field>
      <mat-chip-listbox>
        <mat-chip *ngIf="onlyAssignedTasks.value">
          {{ 'planning.showTasks.myTasks' | translate }}
          <button
            matChipRemove
            (click)="onlyAssignedTasks.setValue(false)">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        <mat-chip *ngIf="includeFinished.value">
          {{ 'planning.showTasks.includeFinished' | translate }}
          <button
            matChipRemove
            (click)="includeFinished.setValue(false)">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        <mat-chip *ngIf="includeUnplanned.value">
          {{ 'planning.showTasks.includeUnplanned' | translate }}
          <button
            matChipRemove
            (click)="includeUnplanned.setValue(false)">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-listbox>
    </div>

    <div style="margin-top: 12px" class="mat-elevation-z6">
      <ng-container *ngIf="tasks$ | async as tasks; else noTasks">
        <ng-container *ngFor="let task of tasks; index as i">
          <p4m-mobile-task-component [taskComponentConfig]="ppsService.getTaskComponentConfig()" [task]="task"
                                     [showResource]="true"></p4m-mobile-task-component>
          <mat-divider *ngIf="i < tasks.length" vertical="false"></mat-divider>
        </ng-container>
      </ng-container>
      <ng-template #noTasks>
        <h3>{{ 'general.infoPanels.vc.noTasksFound' | translate }}</h3>
      </ng-template>
    </div>
  </div>
</ng-container>
